module.exports = __webpack_public_path__ + "static/media/video-02.46e97370.mp4";